import React from 'react';
import Scroll from 'react-scroll';


const HeaderLink = (props) => (
    <Scroll.Link
        to={props.name}
        spy={true}
        hashSpy={true}
        smooth={'easeInOutExpo'}
        offset={-80}
        duration={600}
        activeClass="active-link"
    >
        {props.children}
    </Scroll.Link>
);

export default HeaderLink;


// WEBPACK FOOTER //
// ./src/Components/HeaderLink.js